import TemplatesList from "../components/templates/TemplatesList"

export default function TemplatesPage() {
  return <TemplatesList />
}